export const newFormList = ["internet-i-mobilnaya-svyaz", "internet-tv-mobile"];
